<template>
    <v-container class="pa-0 ma-0">
        <div @click="openDialog()">
            <template v-if="button">
                <v-btn size="x-small" elevation="0" icon="$fa-university"> </v-btn>
            </template>
            <template v-else>
                <v-select
                    v-model="value"
                    :items="activities"
                    attach
                    chips
                    return-object
                    :label="label"
                    multiple
                    disabled
                    :hide-details="hideDetails"
                    density="compact"
                    :item-title="(item) => item.name"
                >
                    <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index < 3">
                            <span>{{ item.name }}</span>
                        </v-chip>
                        <span v-if="index === 3" class="grey--text caption"
                            >(+{{ value.length - 3 }} others)</span
                        >
                    </template>
                </v-select>
            </template>
        </div>
        <oss-dialog
            @keydown.esc="dialogActivitySelection = false"
            v-model="dialogActivitySelection"
            v-if="dialogActivitySelection"
            :min-width="!$vuetify.display.mobile ? '500px' : undefined"
            :max-width="!$vuetify.display.mobile ? '600px' : undefined"
            :min-height="!$vuetify.display.mobile ? '600px' : undefined"
            :fullscreen="$vuetify.display.mobile"
            :hide-overlay="$vuetify.display.mobile"
            :title="'Sélectionnez un code NAF'"
        >
            <!-- <v-toolbar  color="primary">
                    <v-toolbar-title>Sélectionnez un code NAF</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogActivitySelection = false">
                        <v-icon>$close</v-icon>
                    </v-btn>
                </v-toolbar> -->
            <v-card-text class="pt-3">
                <v-text-field-filled
                    v-model="activitySearch"
                    label="Recherche"
                    autofocus
                    density="compact"
                />
                <v-row no-gutters v-if="multiple" class="py-2">
                    <v-col cols="6" class="d-flex justify-center">
                        <v-btn color="primary" size="small" @click="selectAll()">
                            Tout sélectionner
                            <v-icon right>$check_box</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-center">
                        <v-btn color="primary" size="small" @click="clearAll()">
                            Tout désélectionner
                            <v-icon right>$check_box_outline_blank</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-list>
                    <v-virtual-scroll :item-height="84" :items="activities" height="300">
                        <template v-slot="{ item }">
                            <v-list-item
                                :key="item.id"
                                @click="isAdd(item)"
                                class="oss-list-item mb-2"
                            >
                                <v-list-item-title> {{ getActivityName(item) }} </v-list-item-title>
                                <v-list-item-subtitle>{{ item.description }}</v-list-item-subtitle>
                                <template v-slot:append>
                                    <v-icon v-if="isSelected(item)">
                                        {{ multiple ? "$check_box" : "$radio_button_checked" }}
                                    </v-icon>
                                    <v-icon v-else>
                                        {{
                                            multiple
                                                ? "$check_box_outline_blank"
                                                : "$radio_button_unchecked"
                                        }}
                                    </v-icon>
                                </template>
                            </v-list-item>
                        </template>
                    </v-virtual-scroll>
                </v-list>
            </v-card-text>
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";

import COMPANIES_ACTIVITIES from "../../graphql/CompanyActivities.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop, Model } from "vue-facing-decorator";

@Component
export class ossCompanyActivitySelector extends Vue {
    @Prop({ default: null }) inActivities: any;
    @Prop({ default: false }) multiple;
    @Prop({ default: "Code NAF" }) label;
    @Prop({ default: false }) button;
    @Prop({ default: false }) hideDetails;

    dialogActivitySelection = false;

    @Model() value;

    activitySearch = "";

    get where() {
        if (this.activitySearch) {
            const where = {
                OR: [
                    { name_contains: this.activitySearch },
                    { description_contains: this.activitySearch },
                ],
            };
            return where;
        }
        return undefined;
    }

    @Apollo({
        query: COMPANIES_ACTIVITIES,
        variables() {
            return {
                where: this.where,
            };
        },
        // skip() {
        //     return this.inActivities?.length
        // },
        specificResult({ data, loading, networkStatus }: any) {
            this.loadingDocument = loading;
            if (!loading) {
                if (data && data.companyActivities && data.companyActivities.length) {
                    this.items = data.companyActivities;
                } else {
                    this.items = [];
                }
            }
        },
    })
    items = [];

    get activities() {
        if (this.inActivities?.length) {
            return this.inActivities;
        }
        return this.items;
    }

    openDialog() {
        this.dialogActivitySelection = true;
    }

    isAdd(item) {
        if (this.multiple) {
            const verif = this.value.filter((x) => x.id !== item.id);
            if (verif.length === this.value.length) {
                this.value = [...this.value, item];
            } else {
                this.value = verif;
            }
        } else {
            this.value = item;
        }
    }

    isSelected(item) {
        if (this.multiple) {
            const verif = this.value.filter((x) => x.id !== item.id);
            if (verif.length === this.value.length) {
                return false;
            }
            return true;
        }
        if (this.value.id === item.id) {
            return true;
        }

        return false;
    }

    getActivityName(activity) {
        return activity.name;
    }

    selectAll() {
        this.value = this.items;
    }

    clearAll() {
        this.value = [];
    }
}

export default toNative(ossCompanyActivitySelector);
</script>
